

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { Loading } from '../../../../../Helper/Loading'
import Header from '../../../../../Components/Header/Header'
import Sidebar from '../../../../../Components/Sidebar/Sidebar'
import { useAuthState } from '../../../../../Helper/Context'
import { Pegination } from '../../../../../Components/Pegination/Pegination'
import { WorkNameDDL } from '../../../../../Components/CommonDDL/WorkNameDDL'
import DeletePopup from '../../GardenPopup/DeletePopup'
import AddElectricalPillarPopUp from './Modal/AddElectricalPillarPopUp'
import { DummyDDL } from '../../../../../Components/CommonDDL/DummyDDL'
import { LocationDDL } from '../../../../../Components/CommonDDL/LocationDDL'
import { WardNameDataDDL } from '../../../../../Components/CommonDDL/WardNameDataDDL'
import { PillerELEMasterDeleteAPI, PillerEleMasterTableDataAPI } from '../../../../../Redux/ElectricalSlice/PillerSlice'
import { PillerDDL } from '../../../../../Components/CommonDDL/PillerDDL'
import { EleStatusDDL } from '../../../../../Components/CommonDDL/EleStatusDDL'

export const ElectricalPillarMaster = () => {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")


    // console.log(DashboardName)

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: '0',
        Label: "Select...",
    })

    const [LocationName, setLocationName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [StatusName, setStatusName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [PillerID, setPillerID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [Designation, setDesignation] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [DesignationPopupShow, setDesignationPopupShow] = useState()

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setDesignationPopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setDesignationPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setDesignationPopupShow(false)
        handleIsPost()
    }

    const [PopUpField, setPopUpField] = React.useState({
        addPopUp: false,
        deletePopUp: false,
        popupFlag: '',
        popupBtn: "",
        apiFlag: "",
        rowData: ''
    })
    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })
        setLocationName({
            ...LocationName,
            ID: 0,
            Label: 'Select...',
        })
        setPillerID({
            ...PillerID,
            ID: 0,
            Label: 'Select...',
        })
        setStatusName({
            ...StatusName,
            ID: 0,
            Label: 'Select...',
        })
        // console.log("call")
    }


    const handleIsPost = () => {
        setIsPost(!IsPost)
    }


    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    useEffect(() => {
        const data = {
            M_ELEC_PillerID: PillerID?.ID,
            M_ELEC_LocationID: LocationName?.ID,
            Active_M_ELEC_StatusID: StatusName?.ID,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            M_WardID: WardName?.ID,
        }
        dispatch(PillerEleMasterTableDataAPI({ data }))
    }, [IsPost, To, IsClear, isSearch, PillerID?.ID, WardName?.ID, LocationName?.ID, StatusName?.ID])

    const { tableData, isLoading } = useSelector(state => state.PillerEleMasterTableData)

    useEffect(() => {
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
    }, [Designation.ID])

    const handleDeleteApi = (item) => {
        const data = {
            M_ELEC_PillerID: item?.m_eleC_PillerID,
            M_UserID: UserID,
            handleIsPost: handleIsPost,
            token: token,
            handleDeleteCloseClick: handleDeleteCloseClick
        }
        dispatch(PillerELEMasterDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.PillerELEMasterDeleteData)

    const handleDeleteCloseClick = () => {
        setDesignationPopupShow(false)
    }

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}

            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        active="piller" listActive="active" />

                    <div id="" className="content1">
                        <div className="data_mob1">
                            <div className="row m-1 py-1 pb-4 master_border">

                                <div className='col-12 row'>
                                    <div className="col-12 col-lg-5">
                                        <h5 className="ps-1 py-1">Piller Master</h5>
                                    </div>

                                    <div className="col-12 col-lg-3">
                                        <h5 className="ps-1 py-1">Total Count =
                                            <text style={{ color: '#048A8B', fontSize: '18px' }}>
                                                &nbsp;{tableData && tableData.table && tableData.table.length > 0 && tableData.table[0]?.totalCount ? tableData.table[0]?.totalCount : '0'}
                                            </text>
                                        </h5>
                                    </div>

                                    <div className="col-12 col-lg-4 float-end mt-4 pt-1">
                                        {/* <DesignationPopup
                                            open={DesignationPopupShow}
                                            handleIsPost={handleIsPost}
                                        /> */}
                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white", marginTop: '-2em' }} onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>

                                {/* <div>
                                    <h5 className="ps-1 py-1">Piller Master</h5>
                                    <div className="col-12 col-lg-7 float-end">
                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white", marginTop: '-2em' }} onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div> */}

                                <div className="row m-0 ">
                                    <div className="col-12 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12">

                                            <div className="row py-1 rounded2">
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        HWard={HWard}
                                                        WLable={WLable}
                                                        Type="Electrical"
                                                        APIFlag="ProjectWiseWard"
                                                        IsPost={IsPost}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <LocationDDL
                                                        WardName={WardName}
                                                        LocationName={LocationName}
                                                        setLocationName={setLocationName}
                                                        APIFlag="Master"
                                                        IsPost={IsPost}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <EleStatusDDL
                                                        StatusName={StatusName}
                                                        setStatusName={setStatusName}
                                                        APIFlag="Master"
                                                        IsPost={IsPost}
                                                    />
                                                </div>

                                                {/* <div className="col-12 col-md-4 col-lg-3">
                                                    <PillerDDL
                                                        PillerID={PillerID}
                                                        setPillerID={setPillerID}
                                                        WardName={WardName}
                                                        LocationName={LocationName}
                                                        APIFlag="Master"
                                                        IsPost={IsPost}
                                                    />
                                                </div> */}

                                                <div className="col-12 col-md-3 col-lg-3 mt-lg-4 mt-md-4 d-md-flex" >
                                                    {/* <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button> */}
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table
                                                    id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Ward Name</th>
                                                            <th>Location</th>
                                                            <th>Piller No</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((i) =>
                                                                <tr style={{ width: '100%' }}>
                                                                    <td style={{ textAlign: "center" }}>{i?.rowNum}</td>
                                                                    <td>{i?.wardName}</td>
                                                                    <td>{i?.locationName}</td>
                                                                    <td style={{ textAlign: "center", width: '10%' }}>{i?.pillerNo}</td>
                                                                    <td style={{ textAlign: "center", width: '10%' }}>
                                                                        <text style={{ color: i?.active_M_ELEC_StatusID == 1 ? 'green' : 'red' }}>{i?.activeStatus}</text>
                                                                    </td>
                                                                    <td style={{ textAlign: "center", width: '7%' }}>

                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                // onClick={() => handleEditOnClick(item)}
                                                                                onClick={() => handleEditOnClick(i)}
                                                                            >
                                                                            </i>
                                                                        </span>

                                                                        <span>
                                                                            <DeletePopup
                                                                                open={DeletePopupShow}
                                                                                handleDeleteApi={handleDeleteApi}
                                                                                item={i}
                                                                            />
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ) :
                                                                <td colSpan={15}>No data found</td>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {
                    DesignationPopupShow ?
                        <AddElectricalPillarPopUp
                            open={DesignationPopupShow}
                            // popupHeading="Location Name"                         
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div>

        </>
    )
}